<template>
  <div>
    <Menu></Menu>
    <div class="admin-container">
      <div class="left-sidebar">
        <div class="left-sidebar__header">
          <img src="/static/img/pictos/vis.svg" class="" />
          <span>Produits</span>
        </div>
      </div>
      <div class="content-area">
        <h1>Produits</h1>
        <b-container fluid>
          <b-row>
            <b-col>
              <backlink />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="ibox">
                <div class="ibox-content">
                  <AdminForm
                    :config="config"
                    :form="form"
                    :isBusy="isBusy"
                    :options="options"
                    @submit:create:success="postFile"
                    @submit:update:success="postFile"
                  ></AdminForm>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Global/Menu";
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "AdminProductForm",
  components: {
    Menu,
    AdminForm,
  },
  data() {
    return {
      config: config,
      form: {
        photos: [],
        documents: [],
        specifications: [],
      },
      isBusy: false,
      initialForm: {},
    };
  },
  computed: {
    options: function () {
      return {
        family_id_options: this.$store.getters["productfamily/getAll"].selectOptions("id", "name"),
      };
    },
  },
  mounted() {
    // Edition
    if (this.$route.name == config.edit_route_name) {
      this.isBusy = true;
      this.$store.dispatch(config.store_namespace + "/getAll", true).then(() => {
        // let item = this.$store.getters[config.store_namespace + "/getItem"](
        //   this.$route.params.id
        // );
        let item = _.cloneDeep(
          this.$store.getters[config.store_namespace + "/getItem"](this.$route.params.id)
        );
        this.form = {
          ...item,
          // street: item.address.street,
          // zipCode: item.address.zip_code,
          // city: item.address.city,
          family_id: item.family ? item.family.id : null,
        };
        // On sauvegarde les données initiales, donc avant modification dans le form, pour ensuite
        // les utiliser dans la gestion des fichiers joints
        this.initialForm = _.cloneDeep(this.form);
        this.isBusy = false;
      });
    }
  },
  methods: {
    postFile(response) {
      // Si il ya des fichiers
      if (this.form.photos) {
        this.form.photos.forEach((fileLine) => {
          // Si il ne s'agit pas d'un fichier déjà présent
          if (!fileLine.id) {
            let item = {
              product_id: response.data.object.id,
              // type_slug: "complaint-attachment",
              // format: fileLine.file.type,
              name: fileLine.name,
            };

            this.$store.dispatch("photos/addItem", item);
          }
        });
        if (this.initialForm.photos) {
          // Gestion des fichiers supprimés
          // On compare les données du formulaire avant modification avec mes données modifiées
          // pour identifier les fichiers supprimés
          this.initialForm.photos.forEach((fileLine) => {
            // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
            if (!this.form.photos.find((item) => item.id == fileLine.id)) {
              this.$store.dispatch("photos/deleteItem", fileLine.id);
            }
          });
        }
      }

      if (this.form.documents) {
        this.form.documents.forEach((fileLine) => {
          // Si il ne s'agit pas d'un fichier déjà présent
          if (!fileLine.id) {
            let item = {
              product_id: response.data.object.id,
              // type_slug: "complaint-attachment",
              // format: fileLine.file.type,
              name: fileLine.name,
            };

            this.$store.dispatch("documents/addItem", item);
          }
        });
        if (this.initialForm.documents) {
          // Gestion des fichiers supprimés
          // On compare les données du formulaire avant modification avec mes données modifiées
          // pour identifier les fichiers supprimés
          this.initialForm.documents.forEach((fileLine) => {
            // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
            if (!this.form.documents.find((item) => item.id == fileLine.id)) {
              this.$store.dispatch("documents/deleteItem", fileLine.id);
            }
          });
        }
      }

      if (this.form.specifications) {
        this.form.specifications.forEach((spec) => {
          // Si il ne s'agit pas d'un fichier déjà présent
          if (!spec.id) {
            let item = {
              product_id: response.data.object.id,
              name: spec.name,
              value: spec.value,
            };

            this.$store.dispatch("specifications/addItem", item);
          }
        });
        if (this.initialForm.specifications) {
          // Gestion des fichiers supprimés
          // On compare les données du formulaire avant modification avec mes données modifiées
          // pour identifier les fichiers supprimés
          this.initialForm.specifications.forEach((spec) => {
            // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
            if (!this.form.specifications.find((item) => item.id == spec.id)) {
              this.$store.dispatch("specifications/deleteItem", spec.id);
            }
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}
.admin-container {
  display: flex;
  margin-top: 0;
  nav {
    height: 75px;
  }
}
.left-sidebar {
  width: 300px;
  &__header {
    background-color: $color4;
    display: flex;
    height: 300px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 100px;
      margin-left: 35px;
    }
    span {
      color: white;
      font-family: "ClanFFBlack";
      font-size: 20px;
      margin-top: 25px;
      text-transform: uppercase;
    }
  }
}
.container-fluid {
  padding: 0;
}
.content-area {
  width: calc(100% - 300px);
  padding: 40px 7%;
  margin-top: 0;
  h1 {
    font-family: "ClanFFBlack";
    color: $color4;
    font-size: 25px;
    margin-bottom: 0;
    position: relative;
    padding-bottom: 30px;
    &:before {
      content: "";
      display: block;
      width: 60px;
      height: 8px;
      background-color: $color4;
      border-radius: 4px;
      position: absolute;
      bottom: 0;
    }
  }
  .orders__list {
    overflow: auto;
    height: 500px;
    padding-right: 20px;
  }
  &--mobile {
    width: 100%;
    padding: 0;
    margin-top: 0;
    .orders__list {
      height: auto;
      padding: 0;
    }
  }
}
.filters {
  display: flex;
  margin-bottom: 50px;
  .filter {
    height: 35px;
    line-height: 35px;
    border: 1px solid $color1;
  }
  input[type="text"] {
    margin-left: 10px;
    width: auto;
    flex: 1;
    padding: 0 15px;
    font-size: 12px;
  }
  select {
    width: 150px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/AdminProductForm.vue